import React from 'react';
import { LearningStream } from '../services/streams';

interface StreamCardProps {
  stream: LearningStream;
}

const StreamCard: React.FC<StreamCardProps> = ({ stream }) => {
  const progress = stream.target_hours > 0
    ? Math.round((stream.completed_hours / stream.target_hours) * 100)
    : 0;

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'On Track':
        return 'bg-green-100 text-green-800';
      case 'Behind':
        return 'bg-orange-100 text-orange-800';
      case 'Complete':
        return 'bg-blue-100 text-blue-800';
      case 'In Progress':
        return 'bg-yellow-100 text-yellow-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  const getStreamIcon = (name: string) => {
    switch (name) {
      case 'German':
        return 'DE';
      case 'ML_AI':
        return 'ML';
      case 'Research':
        return 'RS';
      case 'Backend':
        return 'BE';
      default:
        return 'LS';
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center">
          <span className="text-xs font-semibold bg-gray-100 text-gray-700 px-2 py-1 rounded mr-3">{getStreamIcon(stream.name)}</span>
          <h3 className="text-xl font-semibold text-gray-900">{stream.name}</h3>
        </div>
        <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(stream.status)}`}>
          {stream.status}
        </span>
      </div>

      <div className="mb-4">
        <div className="w-full bg-gray-200 rounded-full h-3 mb-2">
          <div
            className="bg-primary h-3 rounded-full transition-all duration-300"
            style={{ width: `${Math.min(progress, 100)}%` }}
          />
        </div>
        <div className="flex justify-between text-sm text-gray-600">
          <span>{stream.completed_hours.toFixed(1)}h</span>
          <span>{stream.target_hours}h</span>
        </div>
      </div>

      <div className="text-sm text-gray-500">
        {progress}% complete
      </div>
    </div>
  );
};

export default StreamCard;

